export enum ConfigDataEnum {
  // TODO: CHANGE DEPEND ON WEB BUILD (1) OR DEVICE BUILD (0)
  IS_WEB_BUILD  = 1,
  ONE_SIGNAL_APP_ID = '0bf509da-c4ab-4e66-8a2e-477e46e3b997',
  FCM_SENDER_ID = '433871374756'
}
